<template>
  <el-container
    direction="vertical"
    class="preview-ctr"
    v-bind:style="{ background: layoutBackgroundColor }"
  >
    <header-comp :headerConfig="headerConfig" />
    <div class="fl-content-ctr">
      <div class="fl-content-ctr">
        <div class="comp-ctr">
          <el-row class="comp-row">
            <el-col :span="12">
              <button
                type="button"
                class="el-button el-button--default"
                v-bind:style="{
            background: primaryBackgroundColor,
            borderColor: primaryBorderColor,
            borderRadius: borderRadius
          }"
              >
                <span v-bind:style="{
              color: primaryColor
            }">Primary</span>
              </button>
            </el-col>
            <el-col :span="12">
              <el-button
                v-bind:style="{
            background: primaryBackgroundHoverColor,
            borderColor: primaryBorderHoverColor,
            borderRadius: borderRadius
          }"
              >
                <span
                  v-bind:style="{
              color: primaryHoverColor
            }"
                >Primary Hover</span>
              </el-button>
            </el-col>
          </el-row>
          <el-row class="comp-row">
            <el-col :span="12">
              <el-button
                v-bind:style="{
            background: secondaryBackgroundColor,
            borderColor: secondaryBorderColor,
            borderRadius: borderRadius
          }"
              >
                <span v-bind:style="{
              color: secondaryColor
            }">Secondary</span>
              </el-button>
            </el-col>
            <el-col :span="12">
              <el-button
                v-bind:style="{
            background: secondaryBackgroundHoverColor,
            borderColor: secondaryBorderHoverColor,
            borderRadius: borderRadius
          }"
              >
                <span
                  v-bind:style="{
              color: secondaryHoverColor
            }"
                >Secondary Hover</span>
              </el-button>
            </el-col>
          </el-row>
          <el-row class="comp-row">
            <el-col :span="12">
              <el-button
                v-bind:style="{
            background: deleteBackgroundColor,
            borderColor: deleteBorderColor,
            borderRadius: borderRadius
          }"
              >
                <span v-bind:style="{
              color: deleteColor
            }">Delete</span>
              </el-button>
            </el-col>
            <el-col :span="12">
              <el-button
                v-bind:style="{
            background: deleteBackgroundHoverColor,
            borderColor: deleteBorderHoverColor,
            borderRadius: borderRadius
          }"
              >
                <span
                  v-bind:style="{
              color: deleteHoverColor
            }"
                >Delete Hover</span>
              </el-button>
            </el-col>
          </el-row>
          <el-row class="comp-row">
            <el-col>
              <div class="siteWrapper h_inst_button">
                <div
                  class="siteButton"
                  v-bind:style="{
            background: instBackgroundColor
          }"
                >
                  <div class="siteLogoImage">
                    <img
                      src="./../../assets/images/institution_logo/LOGO_2852_1_2.svg"
                      alt="Bank of America"
                    />
                  </div>
                  <div
                    class="siteDisplayName"
                    v-bind:style="{
            color: instColor
          }"
                  >Bank of America</div>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </el-container>
</template>

<script>
import _ from 'underscore'
import Header from './../fastlink/flHeader.vue'
import { custToolHelper } from '../../mixins/custToolHelper'
export default {
  data() {
    return {}
  },
  components: {
    'header-comp': Header
  },
  created() {},
  mixins: [custToolHelper],
  computed: {
    headerConfig() {
      let config = {
        headerText: 'Buttons'
      }
      return config
    },
    layoutBackgroundColor() {
      return this.getItemDefaultValue('fl-finapp', 'layout_background_color')
    },
    primaryColor() {
      return this.getItemDefaultValue(
        'applyToAll',
        'button_primary_color',
        'primary_buttons'
      )
    },
    primaryBackgroundColor() {
      return this.getItemDefaultValue(
        'applyToAll',
        'button_primary_bg_color',
        'primary_buttons'
      )
    },
    primaryBorderColor() {
      return this.getItemDefaultValue(
        'applyToAll',
        'button_primary_border_color',
        'primary_buttons'
      )
    },
    primaryBorderHoverColor() {
      return this.getItemDefaultValue(
        'applyToAll',
        'button_primary_border_color_hover',
        'primary_buttons'
      )
    },
    primaryHoverColor() {
      return this.getItemDefaultValue(
        'applyToAll',
        'button_primary_hover_color',
        'primary_buttons'
      )
    },

    primaryBackgroundHoverColor() {
      return this.getItemDefaultValue(
        'applyToAll',
        'button_primary_bg_hover_color',
        'primary_buttons'
      )
    },

    secondaryColor() {
      return this.getItemDefaultValue(
        'applyToAll',
        'button_secondary_color',
        'secondary_buttons'
      )
    },

    secondaryBackgroundColor() {
      return this.getItemDefaultValue(
        'applyToAll',
        'button_secondary_bg_color',
        'secondary_buttons'
      )
    },

    secondaryBorderColor() {
      return this.getItemDefaultValue(
        'applyToAll',
        'button_secondary_border_color',
        'secondary_buttons'
      )
    },
    secondaryBorderHoverColor() {
      return this.getItemDefaultValue(
        'applyToAll',
        'button_secondary_border_color_hover',
        'secondary_buttons'
      )
    },
    secondaryHoverColor() {
      return this.getItemDefaultValue(
        'applyToAll',
        'button_secondary_hover_color',
        'secondary_buttons'
      )
    },

    secondaryBackgroundHoverColor() {
      return this.getItemDefaultValue(
        'applyToAll',
        'button_secondary_bg_hover_color',
        'secondary_buttons'
      )
    },

    deleteColor() {
      return this.getItemDefaultValue(
        'applyToAll',
        'button_delete_color',
        'delete_button'
      )
    },

    deleteBackgroundColor() {
      return this.getItemDefaultValue(
        'applyToAll',
        'button_delete_bg_color',
        'delete_button'
      )
    },
    deleteBorderColor() {
      return this.getItemDefaultValue(
        'applyToAll',
        'button_delete_border_color',
        'delete_button'
      )
    },
    deleteBorderHoverColor() {
      return this.getItemDefaultValue(
        'applyToAll',
        'button_delete_border_color_hover',
        'delete_button'
      )
    },
    deleteHoverColor() {
      return this.getItemDefaultValue(
        'applyToAll',
        'button_delete_hover_color',
        'delete_button'
      )
    },
    deleteBackgroundHoverColor() {
      return this.getItemDefaultValue(
        'applyToAll',
        'button_delete_bg_hover_color',
        'delete_button'
      )
    },
    borderRadius() {
      return this.getItemDefaultValue('wellness-finapp', 'button_border_radius')
    },
    instBackgroundColor() {
      return this.getItemDefaultValue(
        'fl-finapp',
        'button_inst_background_color',
        'inst_buttons'
      )
    },
    instColor() {
      return this.getItemDefaultValue(
        'fl-finapp',
        'button_inst_text_color',
        'inst_buttons'
      )
    }
  },
  methods: {}
}
</script>

<style>
.comp-ctr {
}
.comp-row {
  width: 300px;
  margin-bottom: 24px;
}
</style>
